/**
 * All money in the engine is an INTEGER NUMBER OF CENTS. Never use floats for chips.
 *   $1.50 === 150
 */
export type Cents = number;

export const dollars = (d: number): Cents => Math.round(d * 100);

export function formatUSD(cents: Cents): string {
  const sign = cents < 0 ? "-" : "";
  const abs = Math.abs(cents);
  const d = Math.floor(abs / 100);
  const c = abs % 100;
  const whole = d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${sign}$${whole}.${c.toString().padStart(2, "0")}`;
}

/** Casino-style chip denominations in cents, with the traditional colors. */
export const CHIP_DENOMINATIONS: ReadonlyArray<{ value: Cents; color: string }> = [
  { value: 100000, color: "yellow" }, // $1,000
  { value: 50000, color: "purple" }, //  $500
  { value: 10000, color: "black" }, //   $100
  { value: 2500, color: "green" }, //    $25
  { value: 500, color: "red" }, //       $5
  { value: 100, color: "white" }, //     $1
  { value: 25, color: "blue" }, //       $0.25
];

export interface ChipStack {
  value: Cents;
  color: string;
  count: number;
}

/** Greedy "color up": the fewest chips that make up an amount. Remainder below the smallest chip is dropped. */
export function chipBreakdown(cents: Cents): ChipStack[] {
  let left = cents;
  const out: ChipStack[] = [];
  for (const d of CHIP_DENOMINATIONS) {
    const count = Math.floor(left / d.value);
    if (count > 0) {
      out.push({ ...d, count });
      left -= count * d.value;
    }
  }
  return out;
}
